import { PageNodeExtension, PageNodeFormValidationSchema } from '@/modules/Pages';

export const pageNodesValidationSchema: PageNodeFormValidationSchema = {
  slug: [
    { required: true, message: 'Введіть слаг ноди' },
    { type: 'string', message: 'Слаг має бути строкою' },
    { min: 1, max: 255, message: 'Слаг має бути довжиною не менше 1 символа та не більше 255' },
    {
      required: true,
      message: 'Слаг не може містити символи: ? : / . # [ ] @ space tab newline',
      validator: (_, value) => {
        if (value) {
          const match = value.match(/[\t\n\v\f\r #./:?@[\]]/gim);

          if (value === '/' || !match) {
            return Promise.resolve();
          }
        }
        return Promise.reject();
      }
    }
  ],
  siteId: [],
  parentNodeId: [
    {
      required: false,
      message: 'Виберіть батьківську ноду',
      type: 'string'
    }
  ],
  extension: [{ required: false, message: 'Виберіть розширення', type: 'enum', enum: Object.values(PageNodeExtension) }]
};
